import type { ExamMode, Rank } from "../shared/contracts";

export type RankStandard = {
  rank: Rank;
  rounds: string;
  kills: number;
  extractedValue: string;
  tone: string;
  description: string;
};

export const standards: Record<ExamMode, RankStandard[]> = {
  DOUBLE: [
    { rank: "NEW", rounds: "3局取2", kills: 14, extractedValue: "550w", tone: "#8EE6C2", description: "第一道门槛，从稳定撤离开始证明自己。" },
    { rank: "ELITE", rounds: "3局取2", kills: 18, extractedValue: "650w", tone: "#20F08A", description: "节奏与效率并重，失误空间进一步收窄。" },
    { rank: "ACE", rounds: "3局取2", kills: 21, extractedValue: "750w", tone: "#7EA7FF", description: "需要持续压制力，也要让每次撤离有价值。" },
    { rank: "PEAK", rounds: "3局", kills: 30, extractedValue: "850w", tone: "#D59BFF", description: "顶级强度，三局表现共同构成最终证明。" }
  ],
  SINGLE: [
    { rank: "ELITE", rounds: "3局取2", kills: 12, extractedValue: "550w", tone: "#20F08A", description: "独立完成战斗与撤离，考验个人稳定性。" },
    { rank: "ACE", rounds: "3局取2", kills: 16, extractedValue: "650w", tone: "#7EA7FF", description: "个人决策更快，目标价值也同步提升。" },
    { rank: "PEAK", rounds: "3局取3", kills: 24, extractedValue: "750w", tone: "#D59BFF", description: "三局全部计入，以完整表现冲击最高等级。" }
  ]
};

export const specialRules: Record<ExamMode, string> = {
  DOUBLE: "双考5套，只允许一把带一把AW，巴克什监狱每局+人头2个，人头差不能相差3个",
  SINGLE: "不限制装备要求。巴克什监狱每局+1个头"
};

export const rankOrder: Rank[] = ["NEW", "ELITE", "ACE", "PEAK"];


export const femaleEntertainmentRules = [
  "仅支持单考，不分段位；机密、绝密各考一局，每局游戏时间满 15 分钟。",
  "熟悉地图，把考官当作老板互动，提供情绪价值、全程不冷场，并能回答游戏基础问题和陪玩基础知识。",
  "允许鼠鼠玩法，无击杀要求；不得存在技术投诉。"
] as const;

export const femaleTechnicalStandards = {
  SINGLE: [{ rounds: "单局达标", kills: 4, extractedValue: "300W" }, { rounds: "两局累计", kills: 7, extractedValue: "400W" }],
  DOUBLE: [{ rounds: "单局达标", kills: 8, extractedValue: "450W" }, { rounds: "两局累计", kills: 15, extractedValue: "550W" }]
} as const;

export const femaleTechnicalRules = [
  "不分段位，支持单考与双考；单局达标或两局累计达标任选一套，同一套击杀与撤离物资必须同时满足。",
  "装备最高 5 套，只能携带一把狙；禁六套 AW。",
  "监狱巴克什 +2 计入总击杀。",
  "禁止养猪；未成盒前禁止碰尸体。"
] as const;

export const femaleEntryRewards = [
  { assessmentCategory: "FEMALE_ENTERTAINMENT", label: "女娱乐", amount: 66 },
  { assessmentCategory: "FEMALE_TECHNICAL", label: "女技术", amount: 108 }
] as const;
